import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    iconWrapper: {
        paddingBottom: theme.spacing(3),
    },
    linkWrapper: {
        marginTop: theme.spacing(4),
        textAlign: 'center',
    },
    resetPasswordFormWrapper: {
        paddingTop: theme.spacing(3),
        width: 275,
        margin: '0 auto',
        [theme.breakpoints.down('xs')]: {
            width: '90%',
        },
    },
}));
